import i18n from '@signavio/i18n';
import { Popover, useStyles } from '@signavio/ui';
import { Glyph } from '@signavio/ui/core';
import UserGuideLink from './UserGuideLink';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ContextHelp({
  chapter,
  section,
  error,
  children,
  title
}) {
  const styles = useStyles(contextHelpStyles, {}, {
    '&linked': !!chapter
  });
  return /*#__PURE__*/_jsx("div", {
    ...styles,
    children: /*#__PURE__*/_jsx(Popover, {
      title: title,
      popover: /*#__PURE__*/_jsxs("div", {
        ...styles('popover'),
        children: [/*#__PURE__*/_jsx(_Fragment, {
          children: children
        }), chapter && /*#__PURE__*/_jsx("div", {
          ...styles('footer'),
          children: i18n('Click the information icon to open the user guide for more detailed information.')
        })]
      }),
      children: chapter ? /*#__PURE__*/_jsx(UserGuideLink, {
        chapter: chapter,
        section: section,
        children: /*#__PURE__*/_jsx(Glyph, {
          children: error ? 'warning' : 'quick-info'
        })
      }) : /*#__PURE__*/_jsx(Glyph, {
        "data-testid": "context-help",
        children: error ? 'warning' : 'quick-info'
      })
    })
  });
}
const contextHelpStyles = ({
  color,
  font,
  padding,
  spacing
}) => ({
  display: 'inline-block',
  cursor: 'help',
  color: color.primary.base,
  marginLeft: spacing.xxxsmall,
  popover: {
    maxWidth: 600,
    minWidth: 200
  },
  footer: {
    fontSize: font.size.small,
    background: color.primary.light,
    textAlign: 'center',
    marginTop: padding.small,
    marginBottom: -padding.small,
    marginLeft: -padding.small,
    marginRight: -padding.small,
    paddingLeft: padding.small,
    paddingRight: padding.small,
    paddingTop: padding.xsmall,
    paddingBottom: padding.xsmall
  },
  '&linked': {
    cursor: 'pointer'
  }
});
export default ContextHelp;